<template>
    <div class="shipping-block">
        <div class="shipping-block-title-block">
            <div class="shiping-block-info-img">
                    <i class="fas fa-shipping-fast shippinggruz"></i>
                </div>
            <h3 class="section-title">
            КАК МЫ РАБОТАЕМ</h3>
        </div>
       
        <div class="shipping-block-info">
            
            <ul class="shipping-block-info-ul">
                <li>Заказы на сайте можно оформить круглосуточно.</li>
                <li>Режим работы менеджеров - каждый день с <b>8:00</b> до <b>22:00</b>.</li>
                <li>Режим работы производства - с <b>9:00</b> до <b>20:00</b> (ежедневно).</li>
                <li>Доставка товара в радиусе <b>300</b> км от Москвы осуществляется транспортом компании в день заказа, либо в любую указанную вами дату.</li>
                <li>Расчет стоимости доставки большегрузных товаров (свыше <b>100</b> кг) производится по следующим ценам:
                при доставке в пределах МКАД - <b>2000</b> руб за пределами МКАД <b>2000</b> руб плюс <b>50</b> руб за один км от МКАД</li>
                <li>При доставке груза свыше <b>300</b> кг расчет производится индивидуально</li>
                <li>При доставке просим обратить внимание, что доставка производится только одним водителем, который может товар просто довести до пункта назначения.</li>
                <li>В случае невозможности принять товар своими силами (в том числе, при помощи водителя) мы предоставляем услуги по разгрузке и установке, которые оплачиваются отдельно, из расчета <b>1500</b> руб. за одного человека.</li>
                <li>Стоимость доставки не включает разгрузку и установку. Водитель может помочь разгрузить товар из машины. Перенос товара до гаража, ворот, по участку и пр. обговаривается с водителем на месте.</li>
            </ul>
        </div>
    </div>
</template>
<script>

</script>
<style setup>

</style>